import { useEffect } from "react";
import { FileText } from "lucide-react";
import "../styles/legal-page.css";

export default function LegalNoticePage() {
  // Scroll en haut à l'arrivée sur la page
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, []);

  const handleScroll = (event, targetId) => {
    event.preventDefault();

    const element = document.getElementById(targetId);
    if (!element) return;

    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="legal-page">
      {/* HEADER GLOBAL */}
      <header className="legal-header">
        <img
          src="/logo_nms06.png"
          alt="Nouvelles Méthodes Solidaires 06"
          className="legal-logo"
        />
        <FileText className="legal-icon" />
        <h1 className="legal-title">Mentions légales</h1>
        <p className="legal-date">Dernière mise à jour : décembre 2025</p>
      </header>

      {/* LAYOUT : sidebar + contenu */}
      <div className="legal-layout">
        {/* SOMMAIRE */}
        <aside className="legal-sidebar">
          <nav>
            <h2 className="legal-sidebar-title">Sommaire</h2>
            <ul>
              <li>
                <a
                  href="#legal-1"
                  onClick={(e) => handleScroll(e, "legal-1")}
                >
                  1. Éditeur du site
                </a>
              </li>
              <li>
                <a
                  href="#legal-2"
                  onClick={(e) => handleScroll(e, "legal-2")}
                >
                  2. Directeur de la publication
                </a>
              </li>
              <li>
                <a
                  href="#legal-3"
                  onClick={(e) => handleScroll(e, "legal-3")}
                >
                  3. Hébergeur
                </a>
              </li>
              <li>
                <a
                  href="#legal-4"
                  onClick={(e) => handleScroll(e, "legal-4")}
                >
                  4. Objet du site
                </a>
              </li>
              <li>
                <a
                  href="#legal-5"
                  onClick={(e) => handleScroll(e, "legal-5")}
                >
                  5. Propriété intellectuelle
                </a>
              </li>
              <li>
                <a
                  href="#legal-6"
                  onClick={(e) => handleScroll(e, "legal-6")}
                >
                  6. Responsabilité
                </a>
              </li>
              <li>
                <a
                  href="#legal-7"
                  onClick={(e) => handleScroll(e, "legal-7")}
                >
                  7. Données personnelles
                </a>
              </li>
              <li>
                <a
                  href="#legal-8"
                  onClick={(e) => handleScroll(e, "legal-8")}
                >
                  8. Cookies
                </a>
              </li>
              <li>
                <a
                  href="#legal-9"
                  onClick={(e) => handleScroll(e, "legal-9")}
                >
                  9. Liens externes
                </a>
              </li>
              <li>
                <a
                  href="#legal-10"
                  onClick={(e) => handleScroll(e, "legal-10")}
                >
                  10. Droit applicable
                </a>
              </li>
            </ul>
          </nav>
        </aside>

        {/* CONTENU PRINCIPAL */}
        <main className="legal-container">
          <div className="legal-content">
            {/* 1 */}
            <section id="legal-1" className="legal-section">
              <h2>1. Éditeur du site</h2>
              <p>
                Le site <strong>nms06.fr / nms06.com</strong> est édité par :
              </p>
              <ul>
                <li>
                  <strong>Nouvelles Méthodes Solidaires (NMS06)</strong>
                </li>
                <li>Association loi 1901</li>
                <li>251 avenue de la Porte des Alpes</li>
                <li>Plan-du-Var, 06670 Levens – France</li>
                <li>
                  Email :{" "}
                  <a href="mailto:secretariat@nms06.fr">
                    secretariat@nms06.fr
                  </a>
                </li>
                <li>Téléphone : 06 45 42 42 33</li>
              </ul>
            </section>

            {/* 2 */}
            <section id="legal-2" className="legal-section">
              <h2>2. Directeur de la publication</h2>
              <p>Le directeur de la publication est :</p>
              <ul>
                <li>
                  <strong>Nourrédine DEBBARI</strong>, en qualité de Président
                  de l’association NMS06.
                </li>
              </ul>
            </section>

            {/* 3 */}
            <section id="legal-3" className="legal-section">
              <h2>3. Hébergeur</h2>
              <p>Le site est hébergé par :</p>
              <ul>
                <li>
                  <strong>OVHcloud</strong>
                </li>
                <li>OVH SAS, 2 rue Kellermann, 59100 Roubaix – France</li>
                <li>
                  Site :{" "}
                  <a
                    href="https://www.ovhcloud.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ovhcloud.com
                  </a>
                </li>
              </ul>
            </section>

            {/* 4 */}
            <section id="legal-4" className="legal-section">
              <h2>4. Objet du site</h2>
              <p>
                Le site de NMS06 a pour vocation de présenter les actions de
                l’association, de faciliter les adhésions, les dons, les projets
                solidaires, ainsi que certaines animations thématiques activées
                ponctuellement.
              </p>
              <p>
                Les informations publiées sont fournies à titre indicatif et
                peuvent être modifiées à tout moment.
              </p>
            </section>

            {/* 5 */}
            <section id="legal-5" className="legal-section">
              <h2>5. Propriété intellectuelle</h2>
              <p>
                L’ensemble du contenu du site (textes, images, logos, vidéos,
                éléments graphiques, structure, design) est la propriété
                exclusive de NMS06 ou de ses partenaires, sauf mention contraire.
              </p>
              <p>
                Toute reproduction, représentation, modification, diffusion ou
                exploitation, totale ou partielle, sans autorisation écrite
                préalable de NMS06 est interdite et pourrait constituer une
                contrefaçon au sens des articles L.335-2 et suivants du Code de
                la propriété intellectuelle.
              </p>
            </section>

            {/* 6 */}
            <section id="legal-6" className="legal-section">
              <h2>6. Responsabilité</h2>
              <p>
                NMS06 s’efforce de garantir l’exactitude et la mise à jour des
                informations diffusées sur le site, mais ne saurait être tenue
                pour responsable :
              </p>
              <ul>
                <li>des erreurs ou omissions éventuelles ;</li>
                <li>d’un problème technique ou d’indisponibilité du site ;</li>
                <li>de l’utilisation ou interprétation des informations ;</li>
                <li>
                  des dommages résultant de l’accès ou de l’impossibilité
                  d’accès au site.
                </li>
              </ul>
            </section>

            {/* 7 */}
            <section id="legal-7" className="legal-section">
              <h2>7. Données personnelles</h2>
              <p>
                Les informations relatives au traitement des données
                personnelles, aux droits des utilisateurs et aux finalités des
                traitements sont détaillées dans notre{" "}
                <a href="/privacy">
                  Politique de Confidentialité &amp; RGPD
                </a>
                .
              </p>
            </section>

            {/* 8 */}
            <section id="legal-8" className="legal-section">
              <h2>8. Cookies</h2>
              <p>
                Le fonctionnement et la gestion des cookies utilisés sur le site
                sont également précisés dans la{" "}
                <a href="/privacy">
                  Politique de Confidentialité &amp; RGPD
                </a>{" "}
                ainsi que dans le bandeau de consentement affiché lors de votre
                première visite.
              </p>
            </section>

            {/* 9 */}
            <section id="legal-9" className="legal-section">
              <h2>9. Liens externes</h2>
              <p>
                Le site peut contenir des liens vers des sites tiers. NMS06
                n’exerce aucun contrôle sur ces sites et ne peut être tenue
                responsable de leur contenu, de leur fonctionnement ou de leur
                politique de confidentialité.
              </p>
            </section>

            {/* 10 */}
            <section id="legal-10" className="legal-section">
              <h2>10. Droit applicable et juridiction compétente</h2>
              <p>
                Les présentes mentions légales sont soumises au droit français.
                En cas de litige et à défaut de résolution amiable, les tribunaux
                compétents seront ceux du ressort de la Cour d’appel d’Aix-en-Provence,
                sous réserve des règles de compétence d’ordre public.
              </p>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
